import React from 'react';
import { useAuth } from '../contexts/SimpleAuthContext';
import './UserDebug.css';

const UserDebug = () => {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="user-debug-page">
        <div className="debug-container">
          <h1>User Debug - Loading...</h1>
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="user-debug-page">
      <div className="debug-container">
        <h1>User Debug Information</h1>
        
        <div className="debug-section">
          <h2>Authentication Status</h2>
          <div className="debug-item">
            <strong>Is Authenticated:</strong> {isAuthenticated ? '✅ Yes' : '❌ No'}
          </div>
          <div className="debug-item">
            <strong>Loading:</strong> {loading ? '⏳ Yes' : '✅ No'}
          </div>
        </div>

        {user ? (
          <div className="debug-section">
            <h2>User Object</h2>
            <div className="debug-item">
              <strong>ID:</strong> {user.id}
            </div>
            <div className="debug-item">
              <strong>Email:</strong> {user.email}
            </div>
            <div className="debug-item">
              <strong>First Name:</strong> {user.first_name}
            </div>
            <div className="debug-item">
              <strong>Last Name:</strong> {user.last_name}
            </div>
            <div className="debug-item">
              <strong>Role:</strong> {user.role}
            </div>
            <div className="debug-item">
              <strong>Is Staff:</strong> {user.is_staff ? '✅ Yes' : '❌ No'}
            </div>
            <div className="debug-item">
              <strong>Is Superuser:</strong> {user.is_superuser ? '✅ Yes' : '❌ No'}
            </div>
            <div className="debug-item">
              <strong>Is Verified:</strong> {user.is_verified ? '✅ Yes' : '❌ No'}
            </div>
            <div className="debug-item">
              <strong>Date Joined:</strong> {user.date_joined}
            </div>
          </div>
        ) : (
          <div className="debug-section">
            <h2>User Object</h2>
            <div className="debug-item">
              <strong>User:</strong> ❌ No user object found
            </div>
          </div>
        )}

        <div className="debug-section">
          <h2>Analytics Access Check</h2>
          <div className="debug-item">
            <strong>Can Access Analytics:</strong> {
              user && (user.is_staff || user.is_superuser || user.role === 'admin') 
                ? '✅ Yes' 
                : '❌ No'
            }
          </div>
          <div className="debug-item">
            <strong>Reason:</strong> {
              !user 
                ? 'No user logged in'
                : user.is_staff 
                  ? 'User is staff'
                  : user.is_superuser 
                    ? 'User is superuser'
                    : user.role === 'admin'
                      ? 'User has admin role'
                      : 'User lacks required permissions'
            }
          </div>
        </div>

        <div className="debug-section">
          <h2>Raw User Data (JSON)</h2>
          <pre className="debug-json">
            {user ? JSON.stringify(user, null, 2) : 'No user data'}
          </pre>
        </div>

        <div className="debug-section">
          <h2>Local Storage</h2>
          <div className="debug-item">
            <strong>Token:</strong> {localStorage.getItem('token') ? '✅ Present' : '❌ Missing'}
          </div>
          <div className="debug-item">
            <strong>Token Value:</strong> {localStorage.getItem('token') || 'None'}
          </div>
        </div>

        <div className="debug-section">
          <h2>Actions</h2>
          <div className="debug-actions">
            <button 
              onClick={() => window.location.reload()} 
              className="debug-btn"
            >
              🔄 Refresh Page
            </button>
            <button 
              onClick={() => {
                localStorage.removeItem('token');
                window.location.reload();
              }} 
              className="debug-btn danger"
            >
              🚪 Clear Token & Reload
            </button>
            <button 
              onClick={() => {
                console.log('User object:', user);
                console.log('Is authenticated:', isAuthenticated);
                console.log('Token:', localStorage.getItem('token'));
              }} 
              className="debug-btn"
            >
              🐛 Log to Console
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDebug;
